import type { CreateInput } from "@/commands/create/create-input";
export const HARNESSES = [
  "claude-code",
  "codex",
  "cursor",
] as const satisfies readonly NonNullable<CreateInput["harnessPin"]>[];
